module.exports = __webpack_public_path__ + "img/benci.04daf456.png";